export default __webpack_public_path__ + "static/media/saturn.dbfdc2ba.png";